import { Column } from "react-table";

import nameof from "../../../helpers/nameof";
import { Attendee } from "../../../../api";

import TextFilter from "../Components/Filtering/TextFilter";

const Columns: Column<Attendee>[] = [{
  Header: "Name",
  Footer: "Name",
  Filter: TextFilter,
  accessor: nameof<Attendee>("name"),
}, {
  Header: "Company",
  Footer: "Company",
  Filter: TextFilter,
  accessor: nameof<Attendee>("company"),
}, {
  Header: "FCA Number",
  Footer: "FCA Number",
  Filter: TextFilter,
  accessor: nameof<Attendee>("fcaNumber"),
}, {
  Header: "Total Events",
  Footer: "Total Events",
  accessor: attendee => attendee.totalEvents,
  width: "10%",
}, {
  Header: "Average Score",
  Footer: "Average Score",
  accessor: attendee => attendee.scores?.overall,
  width: "10%",
}];

export default Columns;
